import React, { useState } from "react";
import ProfileContainer from "../components/ProfileContainer";
import ProfileWrippleProjectRow from "../components/ProfileWrippleProjectRow";

const MAX_LENGTH = 3;

const TalentProfileWrippleProjects = ({ items = [] }) => {

    const [isMoreOpen, setIsMoreOpen] = useState(false);


    return (
        <div id="wripple-projects" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Wripple Projects  {!!items?.length && `(${items?.length})`}</h4>

                    {!items?.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Wripple Projects Available</p>
                        </div>
                    )}

                    <div className="flex flex-col divide-y">
                        {items?.slice(0, isMoreOpen ? items?.length : MAX_LENGTH).map(project => (
                            <ProfileWrippleProjectRow key={project.id} project={project} />
                        ))}
                    </div>

                    {items?.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                // onClick={() => setIsMoreOpen(!isMoreOpen)}
                                onClick={() => {
                                    setIsMoreOpen(!isMoreOpen)
                                    if (isMoreOpen) {
                                        const element = document.getElementById("wripple-projects");
                                        element.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                            >
                                <p>{items?.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileWrippleProjects;